import angular from 'angular';
import ConfigsModule from '../../configs/configs';
import ServicesModule from '../../services/services';
import ResourcesModule from '../../resources/resources';
import {normalizeTimeframe} from '../../common/datetime/date-ranges';
import CampaignVariationsGetter from '../../services/variationsServices.js';
import {publisherTableFilterToClauses} from './publisherTableFilterToConditions';
import template from './campaignsExplore.jade';
import editBidPriceModalTemplate from './editBidPriceModal.jade';

export class CampaignsExploreController {
  /* @ngInject */
  constructor($stateParams, $state, $scope, $q, currentUser, GamesResource, TargetingResource, CampaignsResource, SegmentAnalyticsResource, MaxBidPricesCampaignBestMatch, ManualMaxBidPrices, Resource, $localStorage, $filter, ggTable, ggCSV, ModalService) {
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$q = $q;
    this.truncate = $filter('truncate');
    this.GamesResource = GamesResource;
    this.CampaignsResource = CampaignsResource;
    this.TargetingResource = TargetingResource;
    this.Resource = Resource;
    this.SegmentAnalyticsResource = SegmentAnalyticsResource;
    this.ManualMaxBidPrices = ManualMaxBidPrices;
    this.MaxBidPricesCampaignBestMatch = MaxBidPricesCampaignBestMatch;
    this.ggTable = ggTable;
    this.ggCSV = ggCSV;
    this.ModalService = ModalService;
    this.query = new Rx.Subject();
    this.$state = $state;
    this.$localStorage = $localStorage;
    this.translate = $filter('translate');
    this.format = $filter('format');
    this.apiDate = $filter('apiDate');
    this.hideRightAxis = true;
    this.MAX_GRAPH_RESULTS = 15;
    this.groupByDate = false;
    this.groupByDateChange = new Rx.BehaviorSubject(undefined);
    this.groupByDateChange.subscribe((groupByDate) => {
      if (this.seriesTable) {
        this.seriesTable.cols
          .filter(col => col.field == 'date')
          .forEach(col => col.show = !!groupByDate);
        this.groupByDate = !!groupByDate;
        this.seriesTable.filter()['group_by_date'] = groupByDate;
        this.seriesTable.reload();
      }
    });

    this.leftAxisSerieChange = new Rx.Subject();
    this.leftAxisSerieChange.subscribe((serie) => {
      if (serie.type == 'pie') {
        this.hideRightAxis = true;
        delete this.series[1];
      } else {
        this.hideRightAxis = false;
      }
      this.setupFilters(serie.seriesName);
      this.buildSeriesTable(serie);
      this.groupByDateChange.onNext(_.get(serie, 'queryParams.group_by_date'));
      this.updateCampaignAnalyticsQuery();
    });

    this.rightAxisSerieChange = new Rx.Subject();
    this.rightAxisSerieChange.subscribe((serie) => {
      this.updateCampaignAnalyticsQuery();
    });

    this.sspConfig = {
      field_label: "Player - SSPs",
    }

    this.filterFieldConfigs = {
      countryCode:{},
      platform:{},
      paying:{},
      acquisitionSource:{},
      ssps:{},
      creativeTypes: {field_label:"Creative Types",possible_values:[
        {
          valueToShow: 'Banner',
          value: 'banner'
        },
        {
          valueToShow: 'Video',
          value: 'video'
        },
        {
          valueToShow: 'Mraid Playable',
          value: 'mraid_playable'
        },
        {
          valueToShow: 'Mraid Banner',
          value: 'mraid_banner'
        },
        {
          valueToShow: 'Playable',
          value: 'playable'
        },
        {
          valueToShow: 'Native Banner',
          value: 'native_banner'
        },
        {
          valueToShow: 'Native Video',
          value: 'native_video'
        },
        {
          valueToShow: 'Dynamic AD',
          value: 'dynamic_ad'
        },
      ]},
    };

    this.availableSearchParams = [
      {key: "countryCode", label: "Country", placeholder: "Country..."},
      {key: "platform", label: "Platform", placeholder: "Platform..."},
      {key: "acquisitionSource", label: "Acquisition Source", placeholder: "Acquisition Source..."},
      {key: "paying", label: "Paying", placeholder: "Paying..."},
      {key: "ssps", label: "SSPs", placeholder: "SSPs..."},
      {key: "creativeTypes", label: "Creative Types", placeholder: "Creative Types..."}
    ];

    this.timeframe = normalizeTimeframe(this.$localStorage.timeframe);
    this.searchParams = {};
    this.series = [];

    this.exploreMetrics = [];

    this.EngagementAndAcquisitionExploreMetrics = (campaign_advertising_type) => ({
      Engagement: [
        {
          metric: 'impressions',
          format: 'number'
        },
        {
          metric: 'clicks',
          format: 'number'
        },
        {
          metric: 'installs',
          title: campaign_advertising_type === "UserAcquisition" ? 'Installs' : 'App Open',
          format: 'number'
        },
        {
          metric: 'installs_rate',
          title: campaign_advertising_type === "UserAcquisition" ? 'Installs Rate' : 'App Open Rate',
          format: 'percentage'
        },
        {
          metric: 'engaged_players',
          format: 'number'
        },
        {
          metric: 'conversion_rate',
          title: 'CR',
          format: 'percentage'
        },
        {
          metric: 'ctr',
          format: 'percentage'
        },
        {
          metric: 'ecpm',
          format: (() => this.currency)
        },
        {
          metric: 'ecpc',
          format: (() => this.currency)
        },
        {
          metric: 'ecpi',
          label: campaign_advertising_type === "UserAcquisition" ? this.translate('ecpi'): this.translate('ecpo'),
          format: (() => this.currency)
        },
        {
          metric: 'ecpa',
          format: (() => this.currency)
        },
        {
          metric: 'cost',
          format: (() => this.currency)
        },
      ],
      Acquisition: [
        {
          metric: 'impressions',
          format: 'number'
        },
        {
          metric: 'clicks',
          format: 'number'
        },
        {
          metric: 'leads',
          format: 'number'
        },
        {
          metric: 'conversion_rate',
          format: 'percentage'
        },
        {
          metric: 'ctr',
          format: 'percentage'
        },
        {
          metric: 'cpqi',
          format: (() => this.currency)
        },
        {
          metric: 'ecpqi',
          format: (() => this.currency)
        }
      ]
    });

    this.getCampaign().then(() => {
      this.getCurrency().then(() => this.updateCampaignAnalyticsQuery());
    });

    this.getCampaigns();

    let vm = this;

    currentUser.subscribe((user) => {
      if(user) {
        this.TargetingResource.one('ssps').get().then(sspChannelTargeting => {
          this.sspsList = this.getSspsArrayForFilterWidget(sspChannelTargeting);
          if (vm.$stateParams.axisName === 'publisher' || vm.$stateParams.axisName === 'ssp') {
            this.filterFieldConfigs.ssps = {...this.sspConfig, possible_values: this.sspsList};
          }
          this.setupFilters(vm.$stateParams.axisName);
        });
      }
    });


    //// TODO remove $watch after ng-change="vm.updateQuery()" is integrated into searchbox component
    $scope.$watch('vm.searchParams', function (newValue) {
      if (newValue) {
        vm.updateCampaignAnalyticsQuery();
      }
    }, true);
  }

  setupFilters(metric) {
    if ((metric === 'publisher' || metric === 'ssp') && this.sspsList) {
      this.filterFieldConfigs.ssps = {...this.sspConfig, possible_values: this.sspsList};

      delete this.filterFieldConfigs.countryCode;
      delete this.filterFieldConfigs.platform;
      delete this.filterFieldConfigs.paying;
      delete this.filterFieldConfigs.acquisitionSource;

      delete this.searchParams.countryCode;
      delete this.searchParams.platform;
      delete this.searchParams.paying;
      delete this.searchParams.acquisitionSource;

    } else if (metric !== 'publisher' && metric !== 'ssp') {
      this.filterFieldConfigs.countryCode = {};
      this.filterFieldConfigs.platform = {};
      this.filterFieldConfigs.paying = {};
      this.filterFieldConfigs.acquisitionSource = {};

      delete this.searchParams.ssps;
      delete this.filterFieldConfigs.ssps;
    }
  }

  getSspsArrayForFilterWidget(sspChannelTargeting) {
    return _.map(sspChannelTargeting, (ssp) => {
      return {
        valueToShow: this.truncate(ssp.id + ' - ' + ssp.name, 20,
            '...'),
        value: '' + ssp.id,
        name: ssp.name,
        id: ssp.id
      };
    });
  }

  setMetricsAndOptions(type, campaign_advertising_type) {
    if (type == 'Acquisition' || type == 'AcquisitionCPM' || type == 'BrandingCPM') {
      // Removed in PEP-4438
    } else {
      this.exploreMetrics = this.EngagementAndAcquisitionExploreMetrics(campaign_advertising_type).Engagement;
    }

    if (type === 'EngagementCPC') {
      this.exploreMetrics = _.filter(this.exploreMetrics, (metric) => metric.metric !== 'ecpm')
    }

    this.exploreMetricsForPublisher = [{
      metric: 'targeted_players',
      format: 'number'
    }, ...this.exploreMetrics];

    this.exploreMetricsForPublisher = this.exploreMetricsForPublisher.map((serie) => {
      return _.assign({}, serie, {
        getData: ((params) => this.getExplorePublisherData(params))
      });
    });

    const engagementCampaignsSeriesOptions = {
      daily_targeted_players: {
        label: this.translate('$analytics.campaign.engagement.series.daily_targeted_players.label'),
        metric: 'daily_targeted_players',
        type: 'spline',
        bigLabel: 'sum',
        format: 'number'
      },
      targeted_players: {
        label: this.translate('$analytics.campaign.engagement.series.targeted_players.label'),
        metric: 'targeted_players',
        type: 'spline',
        bigLabel: 'sum',
        format: 'number'
      },
      engaged_players: {
        label: this.translate('$analytics.campaign.engagement.series.engaged_players.label'),
        metric: 'engaged_players',
        type: 'spline',
        bigLabel: 'sum',
        format: 'number'
      },
      conversion_rate: {
        label: this.translate('$analytics.campaign.engagement.series.conversion_rate.label'),
        metric: 'conversion_rate',
        type: 'spline',
        bigLabel: 'avg',
        format: 'percentage'
      },
      clicks: {
        label: this.translate('$analytics.campaign.performance.series.clicks.label'),
        metric: 'clicks',
        type: 'spline',
        bigLabel: 'sum',
        format: 'number'
      },
      impressions: {
        label: this.translate('$analytics.campaign.performance.series.impressions.label'),
        metric: 'impressions',
        type: 'spline',
        bigLabel: 'sum',
        format: 'number'
      },
      ctr: {
        label: this.translate('$analytics.campaign.performance.series.ctr.label'),
        metric: 'ctr',
        type: 'spline',
        bigLabel: 'avg',
        format: 'percentage'
      },
      cost: {
        label: this.translate('$analytics.campaign.cost.label'),
        metric: 'cost',
        type: 'spline',
        format: (() => this.currency),
        bigLabel: 'sum'
        //decorateSerie: ((serie) => this.applyCampaignCostSerieMarkers(serie))
      },
      topChannels: {
        label: this.translate('channels'),
        seriesName: 'topChannels',
        exploreMetrics: this.exploreMetrics,
        selectedExploreMetric: this.exploreMetrics[1],
        metric: 'clicks',
        format: 'number',
        type: 'pie',
        tooltipType: 'category',
        queryParams: {breakdown_dimension: 'channel', group_by_date: false},
        getData: ((params) => this.CampaignAnalyticsResource.one('explore').get(params)),
        transformSerieResponse: ((res, serie) => this.transformBreakdownResponse(res, serie))
      },
      topCreativeTypes: {
        label: this.translate('creativeTypes'),
        seriesName: 'topCreativeTypes',
        exploreMetrics: this.exploreMetrics,
        selectedExploreMetric: this.exploreMetrics[1],
        metric: 'clicks',
        format: 'number',
        type: 'pie',
        tooltipType: 'category',
        queryParams: {breakdown_dimension: 'creative_type', group_by_date: false},
        getData: ((params) => this.CampaignAnalyticsResource.one('explore').get(params)),
        transformSerieResponse: ((res, serie) => this.transformBreakdownResponse(res, serie))
      },
      creativeId: {
        label: this.translate('$analytics.campaign.creativeId.label'),
        seriesName: 'creativeId',
        exploreMetrics: this.exploreMetrics,
        selectedExploreMetric: this.exploreMetrics[1],
        metric: 'clicks',
        format: 'number',
        type: 'pie',
        tooltipType: 'category',
        queryParams: {breakdown_dimension: 'creative_id', group_by_date: false},
        getData: ((params) => this.CampaignAnalyticsResource.one('explore').get(params)),
        transformSerieResponse: ((res, serie) => this.transformBreakdownResponse(res, serie))
      },
      creativeDimension: {
        label: this.translate('$analytics.campaign.creativeDimension.label'),
        seriesName: 'creativeDimension',
        exploreMetrics: this.exploreMetrics,
        selectedExploreMetric: this.exploreMetrics[1],
        metric: 'clicks',
        format: 'number',
        type: 'pie',
        tooltipType: 'category',
        queryParams: {breakdown_dimension: 'creative_dimensions', group_by_date: false},
        getData: ((params) => this.CampaignAnalyticsResource.one('explore').get(params)),
        transformSerieResponse: ((res, serie) => this.transformBreakdownResponse(res, serie))
      },
      topCountries: {
        label: this.translate('countries'),
        seriesName: 'topCountries',
        exploreMetrics: this.exploreMetrics,
        selectedExploreMetric: this.exploreMetrics[1],
        metric: 'clicks',
        format: 'number',
        type: 'pie',
        tooltipType: 'category',
        queryParams: {breakdown_dimension: 'country', group_by_date: false},
        getData: ((params) => this.CampaignAnalyticsResource.one('explore').get(params)),
        transformSerieResponse: ((res, serie) => this.transformBreakdownResponse(res, serie))
      },
      ssp: {
        label: this.translate('ssp'),
        seriesName: 'ssp',
        exploreMetrics: this.exploreMetricsForPublisher,
        selectedExploreMetric: this.exploreMetricsForPublisher[1],
        metric: 'clicks',
        format: 'number',
        type: 'pie',
        tooltipType: 'category',
        queryParams: {breakdown_dimension: 'ssp_id', group_by_date: false, row_num: 10, order_by: 'impressions', order_direction: 'DESC'},
        getData: ((params) => this.getEnrichedSspData(params)),
        transformSerieResponse: ((res, serie) => this.transformSspResponse(res, serie))
      },
      publisher: {
        label: this.translate('publisher'),
        seriesName: 'publisher',
        exploreMetrics: this.exploreMetricsForPublisher,
        selectedExploreMetric: this.exploreMetricsForPublisher[1],
        metric: 'clicks',
        format: 'number',
        type: 'pie',
        tooltipType: 'category',
        queryParams: {group_by_date: false, row_num: 10, order_by: 'impressions', order_direction: 'DESC'},
        getData: ((params) => this.getEnrichedPublisherData(params)),
        transformSerieResponse: ((res, serie) => this.transformPublisherResponse(res, serie))
      }
    };


    const reengagementCampaignSeriesOptions = {
      app_open: {
        label: this.translate('$analytics.campaign.engagement.series.app_open.label'),
        metric: 'app_open',
        type: 'spline',
        bigLabel: 'sum',
        format: 'number'
      },
      app_open_rate: {
        label: this.translate('$analytics.campaign.engagement.series.app_open_rate.label'),
        metric: 'app_open_rate',
        type: 'spline',
        bigLabel: 'avg',
        format: 'percentage'
      }
    }

    const userAcquisitionCampaignSeriesOptions = {
      installs: {
        label: this.translate('$analytics.campaign.engagement.series.installs.label'),
        metric: 'installs',
        type: 'spline',
        bigLabel: 'sum',
        format: 'number'
      },
      installs_rate: {
        label: this.translate('$analytics.campaign.engagement.series.installs_rate.label'),
        metric: 'installs_rate',
        type: 'spline',
        bigLabel: 'avg',
        format: 'percentage'
      }
    }

    const engagementCampaignsSeriesOptionsByAdvType = campaign_advertising_type === "UserAcquisition" ? userAcquisitionCampaignSeriesOptions : reengagementCampaignSeriesOptions;

    const engagementCampaignsSeriesOptionsExtended = {
      ...engagementCampaignsSeriesOptions,
      ...engagementCampaignsSeriesOptionsByAdvType
    }

    this.seriesOptions = {
      Engagement: _.cloneDeep(engagementCampaignsSeriesOptionsExtended),
      EngagementCPC: _.cloneDeep(engagementCampaignsSeriesOptionsExtended),
      EngagementCPA: _.cloneDeep(engagementCampaignsSeriesOptionsExtended),
      EngagementCPI: _.cloneDeep(engagementCampaignsSeriesOptionsExtended),
      Acquisition: {
        clicks: {
          label: this.translate('$analytics.campaign.performance.series.clicks.label'),
          metric: 'clicks',
          type: 'spline',
          bigLabel: 'sum',
          format: 'number'
        },
        impressions: {
          label: this.translate('$analytics.campaign.performance.series.impressions.label'),
          metric: 'impressions',
          type: 'spline',
          bigLabel: 'sum',
          format: 'number'
        },
        ctr: {
          label: this.translate('$analytics.campaign.performance.series.ctr.label'),
          metric: 'ctr',
          type: 'spline',
          bigLabel: 'avg',
          format: 'percentage'
        },
        leads: {
          label: this.translate('$analytics.campaign.performance.series.leads.label'),
          metric: 'leads',
          type: 'spline',
          bigLabel: 'sum',
          format: 'number'
        },
        cost: {
          label: this.translate('$analytics.campaign.cost.label'),
          metric: 'cost',
          type: 'spline',
          format: (() => this.currency),
          bigLabel: 'sum'
          //decorateSerie: ((serie) => this.applyCampaignCostSerieMarkers(serie))
        },
        topChannels: {
          label: this.translate('channels'),
          seriesName: 'topChannels',
          exploreMetrics: this.exploreMetrics,
          selectedExploreMetric: this.exploreMetrics[1],
          metric: 'clicks',
          format: 'number',
          type: 'pie',
          tooltipType: 'category',
          queryParams: {breakdown_dimension: 'channel', group_by_date: false},
          getData: ((params) => this.CampaignAnalyticsResource.one('explore').get(params)),
          transformSerieResponse: ((res, serie) => this.transformBreakdownResponse(res, serie))
        },
        topCreativeTypes: {
          label: this.translate('creativeTypes'),
          seriesName: 'topCreativeTypes',
          exploreMetrics: this.exploreMetrics,
          selectedExploreMetric: this.exploreMetrics[1],
          metric: 'clicks',
          format: 'number',
          type: 'pie',
          tooltipType: 'category',
          queryParams: {breakdown_dimension: 'creative_type', group_by_date: false},
          getData: ((params) => this.CampaignAnalyticsResource.one('explore').get(params)),
          transformSerieResponse: ((res, serie) => this.transformBreakdownResponse(res, serie))
        },
        creativeId: {
          label: this.translate('$analytics.campaign.creativeId.label'),
          seriesName: 'creativeId',
          exploreMetrics: this.exploreMetrics,
          selectedExploreMetric: this.exploreMetrics[1],
          metric: 'clicks',
          format: 'number',
          type: 'pie',
          tooltipType: 'category',
          queryParams: {breakdown_dimension: 'creative_id', group_by_date: false},
          getData: ((params) => this.CampaignAnalyticsResource.one('explore').get(params)),
          transformSerieResponse: ((res, serie) => this.transformBreakdownResponse(res, serie))
        },
        creativeDimension: {
          label: this.translate('$analytics.campaign.creativeDimension.label'),
          seriesName: 'creativeDimension',
          exploreMetrics: this.exploreMetrics,
          selectedExploreMetric: this.exploreMetrics[1],
          metric: 'clicks',
          format: 'number',
          type: 'pie',
          tooltipType: 'category',
          queryParams: {breakdown_dimension: 'creative_dimensions', group_by_date: false},
          getData: ((params) => this.CampaignAnalyticsResource.one('explore').get(params)),
          transformSerieResponse: ((res, serie) => this.transformBreakdownResponse(res, serie))
        },
        topCountries: {
          label: this.translate('countries'),
          seriesName: 'topCountries',
          exploreMetrics: this.exploreMetrics,
          selectedExploreMetric: this.exploreMetrics[1],
          metric: 'clicks',
          format: 'number',
          type: 'pie',
          tooltipType: 'category',
          queryParams: {breakdown_dimension: 'country', group_by_date: false},
          getData: ((params) => this.CampaignAnalyticsResource.one('explore').get(params)),
          transformSerieResponse: ((res, serie) => this.transformBreakdownResponse(res, serie))
        },
        ssp: {
          label: this.translate('ssp'),
          seriesName: 'ssp',
          exploreMetrics: this.exploreMetricsForPublisher,
          selectedExploreMetric: this.exploreMetricsForPublisher[1],
          metric: 'clicks',
          format: 'number',
          type: 'pie',
          tooltipType: 'category',
          queryParams: {breakdown_dimension: 'ssp_id', group_by_date: false, row_num: 10, order_by: 'impressions', order_direction: 'DESC'},
          getData: ((params) => this.getEnrichedSspData(params)),
          transformSerieResponse: ((res, serie) => this.transformSspResponse(res, serie))
        },
        publisher: {
          label: this.translate('publisher'),
          seriesName: 'publisher',
          exploreMetrics: this.exploreMetricsForPublisher,
          selectedExploreMetric: this.exploreMetricsForPublisher[1],
          metric: 'clicks',
          format: 'number',
          type: 'pie',
          tooltipType: 'category',
          queryParams: {group_by_date: false, row_num: 10, order_by: 'impressions', order_direction: 'DESC'},
          getData: ((params) => this.getEnrichedPublisherData(params)),
          transformSerieResponse: ((res, serie) => this.transformPublisherResponse(res, serie))
        }
      },
      AcquisitionCPM: {
        clicks: {
          label: this.translate('$analytics.campaign.performance.series.clicks.label'),
          metric: 'clicks',
          type: 'spline',
          bigLabel: 'sum',
          format: 'number'
        },
        impressions: {
          label: this.translate('$analytics.campaign.performance.series.impressions.label'),
          metric: 'impressions',
          type: 'spline',
          bigLabel: 'sum',
          format: 'number'
        },
        ctr: {
          label: this.translate('$analytics.campaign.performance.series.ctr.label'),
          metric: 'ctr',
          type: 'spline',
          bigLabel: 'avg',
          format: 'percentage'
        },
        leads: {
          label: this.translate('$analytics.campaign.performance.series.leads.label'),
          metric: 'leads',
          type: 'spline',
          bigLabel: 'sum',
          format: 'number'
        },
        cost: {
          label: this.translate('$analytics.campaign.cost.label'),
          metric: 'cost',
          type: 'spline',
          format: (() => this.currency),
          bigLabel: 'sum'
          //decorateSerie: ((serie) => this.applyCampaignCostSerieMarkers(serie))
        },
        topChannels: {
          label: this.translate('channels'),
          seriesName: 'topChannels',
          exploreMetrics: this.exploreMetrics,
          selectedExploreMetric: this.exploreMetrics[1],
          metric: 'clicks',
          format: 'number',
          type: 'pie',
          tooltipType: 'category',
          queryParams: {breakdown_dimension: 'channel', group_by_date: false},
          getData: ((params) => this.CampaignAnalyticsResource.one('explore').get(params)),
          transformSerieResponse: ((res, serie) => this.transformBreakdownResponse(res, serie))
        },
        topCreativeTypes: {
          label: this.translate('creativeTypes'),
          seriesName: 'topCreativeTypes',
          exploreMetrics: this.exploreMetrics,
          selectedExploreMetric: this.exploreMetrics[1],
          metric: 'clicks',
          format: 'number',
          type: 'pie',
          tooltipType: 'category',
          queryParams: {breakdown_dimension: 'creative_type', group_by_date: false},
          getData: ((params) => this.CampaignAnalyticsResource.one('explore').get(params)),
          transformSerieResponse: ((res, serie) => this.transformBreakdownResponse(res, serie))
        },
        creativeId: {
          label: this.translate('$analytics.campaign.creativeId.label'),
          seriesName: 'creativeId',
          exploreMetrics: this.exploreMetrics,
          selectedExploreMetric: this.exploreMetrics[1],
          metric: 'clicks',
          format: 'number',
          type: 'pie',
          tooltipType: 'category',
          queryParams: {breakdown_dimension: 'creative_id', group_by_date: false},
          getData: ((params) => this.CampaignAnalyticsResource.one('explore').get(params)),
          transformSerieResponse: ((res, serie) => this.transformBreakdownResponse(res, serie))
        },
        creativeDimension: {
          label: this.translate('$analytics.campaign.creativeDimension.label'),
          seriesName: 'creativeDimension',
          exploreMetrics: this.exploreMetrics,
          selectedExploreMetric: this.exploreMetrics[1],
          metric: 'clicks',
          format: 'number',
          type: 'pie',
          tooltipType: 'category',
          queryParams: {breakdown_dimension: 'creative_dimensions', group_by_date: false},
          getData: ((params) => this.CampaignAnalyticsResource.one('explore').get(params)),
          transformSerieResponse: ((res, serie) => this.transformBreakdownResponse(res, serie))
        },
        topCountries: {
          label: this.translate('countries'),
          seriesName: 'topCountries',
          exploreMetrics: this.exploreMetrics,
          selectedExploreMetric: this.exploreMetrics[1],
          metric: 'clicks',
          format: 'number',
          type: 'pie',
          tooltipType: 'category',
          queryParams: {breakdown_dimension: 'country', group_by_date: false},
          getData: ((params) => this.CampaignAnalyticsResource.one('explore').get(params)),
          transformSerieResponse: ((res, serie) => this.transformBreakdownResponse(res, serie))
        },
        ssp: {
          label: this.translate('ssp'),
          seriesName: 'ssp',
          exploreMetrics: this.exploreMetricsForPublisher,
          selectedExploreMetric: this.exploreMetricsForPublisher[1],
          metric: 'clicks',
          format: 'number',
          type: 'pie',
          tooltipType: 'category',
          queryParams: {breakdown_dimension: 'ssp_id', group_by_date: false, row_num: 10, order_by: 'impressions', order_direction: 'DESC'},
          getData: ((params) => this.getEnrichedSspData(params)),
          transformSerieResponse: ((res, serie) => this.transformSspResponse(res, serie))
        },
        publisher: {
          label: this.translate('publisher'),
          seriesName: 'publisher',
          exploreMetrics: this.exploreMetricsForPublisher,
          selectedExploreMetric: this.exploreMetricsForPublisher[1],
          metric: 'clicks',
          format: 'number',
          type: 'pie',
          tooltipType: 'category',
          queryParams: {group_by_date: false, row_num: 10, order_by: 'impressions', order_direction: 'DESC'},
          getData: ((params) => this.getEnrichedPublisherData(params)),
          transformSerieResponse: ((res, serie) => this.transformPublisherResponse(res, serie))
        }
      },
      BrandingCPM: {
        clicks: {
          label: this.translate('$analytics.campaign.performance.series.clicks.label'),
          metric: 'clicks',
          type: 'spline',
          bigLabel: 'sum',
          format: 'number'
        },
        impressions: {
          label: this.translate('$analytics.campaign.performance.series.impressions.label'),
          metric: 'impressions',
          type: 'spline',
          bigLabel: 'sum',
          format: 'number'
        },
        ctr: {
          label: this.translate('$analytics.campaign.performance.series.ctr.label'),
          metric: 'ctr',
          type: 'spline',
          bigLabel: 'avg',
          format: 'percentage'
        },
        leads: {
          label: this.translate('$analytics.campaign.performance.series.leads.label'),
          metric: 'leads',
          type: 'spline',
          bigLabel: 'sum',
          format: 'number'
        },
        cost: {
          label: this.translate('$analytics.campaign.cost.label'),
          metric: 'cost',
          type: 'spline',
          format: (() => this.currency),
          bigLabel: 'sum'
          //decorateSerie: ((serie) => this.applyCampaignCostSerieMarkers(serie))
        },
        topChannels: {
          label: this.translate('channels'),
          seriesName: 'topChannels',
          exploreMetrics: this.exploreMetrics,
          selectedExploreMetric: this.exploreMetrics[1],
          metric: 'clicks',
          format: 'number',
          type: 'pie',
          tooltipType: 'category',
          queryParams: {breakdown_dimension: 'channel', group_by_date: false},
          getData: ((params) => this.CampaignAnalyticsResource.one('explore').get(params)),
          transformSerieResponse: ((res, serie) => this.transformBreakdownResponse(res, serie))
        },
        topCreativeTypes: {
          label: this.translate('creativeTypes'),
          seriesName: 'topCreativeTypes',
          exploreMetrics: this.exploreMetrics,
          selectedExploreMetric: this.exploreMetrics[1],
          metric: 'clicks',
          format: 'number',
          type: 'pie',
          tooltipType: 'category',
          queryParams: {breakdown_dimension: 'creative_type', group_by_date: false},
          getData: ((params) => this.CampaignAnalyticsResource.one('explore').get(params)),
          transformSerieResponse: ((res, serie) => this.transformBreakdownResponse(res, serie))
        },
        creativeId: {
          label: this.translate('$analytics.campaign.creativeId.label'),
          seriesName: 'creativeId',
          exploreMetrics: this.exploreMetrics,
          selectedExploreMetric: this.exploreMetrics[1],
          metric: 'clicks',
          format: 'number',
          type: 'pie',
          tooltipType: 'category',
          queryParams: {breakdown_dimension: 'creative_id', group_by_date: false},
          getData: ((params) => this.CampaignAnalyticsResource.one('explore').get(params)),
          transformSerieResponse: ((res, serie) => this.transformBreakdownResponse(res, serie))
        },
        creativeDimension: {
          label: this.translate('$analytics.campaign.creativeDimension.label'),
          seriesName: 'creativeDimension',
          exploreMetrics: this.exploreMetrics,
          selectedExploreMetric: this.exploreMetrics[1],
          metric: 'clicks',
          format: 'number',
          type: 'pie',
          tooltipType: 'category',
          queryParams: {breakdown_dimension: 'creative_dimensions', group_by_date: false},
          getData: ((params) => this.CampaignAnalyticsResource.one('explore').get(params)),
          transformSerieResponse: ((res, serie) => this.transformBreakdownResponse(res, serie))
        },
        topCountries: {
          label: this.translate('countries'),
          seriesName: 'topCountries',
          exploreMetrics: this.exploreMetrics,
          selectedExploreMetric: this.exploreMetrics[1],
          metric: 'clicks',
          format: 'number',
          type: 'pie',
          tooltipType: 'category',
          queryParams: {breakdown_dimension: 'country', group_by_date: false},
          getData: ((params) => this.CampaignAnalyticsResource.one('explore').get(params)),
          transformSerieResponse: ((res, serie) => this.transformBreakdownResponse(res, serie))
        },
        ssp: {
          label: this.translate('ssp'),
          seriesName: 'ssp',
          exploreMetrics: this.exploreMetricsForPublisher,
          selectedExploreMetric: this.exploreMetricsForPublisher[1],
          metric: 'clicks',
          format: 'number',
          type: 'pie',
          tooltipType: 'category',
          queryParams: {breakdown_dimension: 'ssp_id', group_by_date: false, row_num: 10, order_by: 'impressions', order_direction: 'DESC'},
          getData: ((params) => this.getEnrichedSspData(params)),
          transformSerieResponse: ((res, serie) => this.transformSspResponse(res, serie))
        },
        publisher: {
          label: this.translate('publisher'),
          seriesName: 'publisher',
          exploreMetrics: this.exploreMetricsForPublisher,
          selectedExploreMetric: this.exploreMetricsForPublisher[1],
          metric: 'clicks',
          format: 'number',
          type: 'pie',
          tooltipType: 'category',
          queryParams: {group_by_date: false, row_num: 10, order_by: 'impressions', order_direction: 'DESC'},
          getData: ((params) => this.getEnrichedPublisherData(params)),
          transformSerieResponse: ((res, serie) => this.transformPublisherResponse(res, serie))
        }
      }
    };
  }

  getCampaign() {
    return this.CampaignsResource.one(this.$stateParams.id).get()
      .then((res) => {
        this.setAnalyticsResource(res.type);
        this.setMetricsAndOptions(res.type, res.campaign_advertising_type);
        this.campaign = res;
        this.campaign.game_id = this.$stateParams.gameId;
      });
  }

  getCampaigns() {
    return this.CampaignsResource.getList({game_id: this.$stateParams.gameId})
      .then((res) => this.campaigns = res);
  }

  goToCampaign(campaign) {
    let params = _.clone(this.$stateParams);
    if (campaign.type != this.campaign.type) {
      if (campaign.type == 'Engagement') {
        params.axisName = 'targeted_players';
      } else {
        params.axisName = 'clicks';
      }
    }
    this.$state.go('app.campaigns.explore', _.merge({}, params, {id: campaign.id}));
  }

  setAnalyticsResource(type) {
    if (type == 'Acquisition' || type == 'AcquisitionCPM' || type == 'BrandingCPM') {
      // Removed in PEP-4438
    } else {
      this.CampaignAnalyticsResource = this.Resource('campaign-analytics');
      this.CampaignAnalyticsBreakdownResource = this.Resource('campaign-analytics/breakdown', {baseUrl: '/api/v2'});
    }
  }

  getCurrency() {
    return this.GamesResource.one(this.$stateParams.gameId).get()
      .then((game) => game.getGameDeveloper())
      .then((gameDeveloper) => this.currency = 'USD');
  }

  updateCampaignAnalyticsQuery () {
    this.$localStorage.timeframe = this.timeframe;

    if (!this.campaign) {
      return;
    }

    let query = {
      campaign_id: this.campaign.id,
      start_date: this.apiDate(this.timeframe.startDate),
      end_date: this.apiDate(this.timeframe.endDate),
      countryCode: this.searchParams.countryCode,
      creativeType: this.searchParams.creativeTypes,
      platform: this.searchParams.platform,
      acquisitionSource: this.searchParams.acquisitionSource,
      paying: this.searchParams.paying,
      ssps: this.searchParams.ssps,
      metric: _.chain(this.series).compact().map((s) => `${s.seriesName}_${s.metric}_${s.type}`).join('+').value()
    };

    if (this.timeframe.comparisonStartDate && this.timeframe.comparisonEndDate) {
      query.comparison = {
        start_date: this.apiDate(this.timeframe.comparisonStartDate),
        end_date: this.apiDate(this.timeframe.comparisonEndDate)
      };
    }

    if (this.series.length) {
      this.$state.go('app.campaigns.explore', {axisName: this.series[0].seriesName || this.series[0].metric}, {notify: false});
    }

    this.query.onNext(query);
  }

  getAPIDimensionName(dimensionName) {
    switch(dimensionName) {
        case 'Countries':
          return 'country_code';
        case 'Platforms':
          return 'platform';
        case 'Publisher':
          return 'publisher';
        case 'Channels':
          return 'channel';
        case 'Bundle':
          return 'traffic_source';
        default:
          return '';
    }
  }

  showBidPriceEditModal(dimensionName, dimensionValue, keyOriginal = '') {

    if(dimensionName === 'Countries' || dimensionName === 'Publisher') { dimensionValue = keyOriginal; }

    const params = {
      campaign_id: this.campaign.id,
      [this.getAPIDimensionName(dimensionName)]: dimensionValue
    };

    this.MaxBidPricesCampaignBestMatch.one().get(params).then(res => {
      this.ModalService.showModal({
        template: editBidPriceModalTemplate(),
        controllerAs: 'vm',
        controller: 'EditBidPriceModalController',
        inputs: {
          dimensionName: dimensionName === 'Publisher' ? 'spot' : dimensionName,
          dimensionValue: dimensionValue,
          maxBidPricesCampaignBestMatch: res
        }
      }).then((modal) => {
        modal.close.then((res) => {
          res && this.persistBidPrice(res.plain(), dimensionName, dimensionValue);
        });
      });
    });
  }

  persistBidPrice(bidPrices, dimensionName, dimensionValue) {

    if(this.isUpdateableBestMatch(bidPrices, this.campaign.id, dimensionName, dimensionValue)) {
      this.ManualMaxBidPrices.one(bidPrices.id).customPUT(bidPrices);
    } else {
      delete bidPrices.id;
      bidPrices.campaign_id = this.campaign.id;
      bidPrices[this.getAPIDimensionName(dimensionName)] = dimensionValue;
      bidPrices.client_bid = true;
      this.ManualMaxBidPrices.post(bidPrices);
    }
  }

  isUpdateableBestMatch(bestMatchToPersist, campaignId, dimensionName, dimensionValue) {
    return  bestMatchToPersist.campaign_id === campaignId &&
            bestMatchToPersist[this.getAPIDimensionName(dimensionName)] === dimensionValue &&
            bestMatchToPersist.client_bid;
  }

  addExploreDataBreakdownDimensionKeyAndValue(res, serie) {
    res.explore_data = res.explore_data.map((data) => {
      data.key = data[res.breakdown_dimension];
      if(serie.queryParams.breakdown_dimension == 'platform') {
        data.key = this.translate(data.key);
      } else if(serie.queryParams.breakdown_dimension == 'country') {
        data.keyOriginal = data.key;
        data.key = this.translate(`countryCodes.${data.key}`);
      }
      data.value = data[serie.metric];
      return data;
    });
  }

  transformBreakdownResponse(res, serie) {
    this.addExploreDataBreakdownDimensionKeyAndValue(res, serie);

    let tableCols = [
      {
        field: 'date',
        filter: {key: 'text'},
        sortable: 'date',
        title: 'Date',
        format: 'date',
        show: this.groupByDate
      },
      {
        field: 'group_by_date',
        show: false
      },
      {
        field: 'keyOriginal',
        show: false
      },
      {
        field: 'key',
        filter: {key: 'text'},
        sortable: 'key',
        title: serie.label,
        show: true
      },
      {
        field: 'name',
        filter: {key: 'text'},
        sortable: 'name',
        title: 'Name',
        show: serie.queryParams.breakdown_dimension === 'creative_id'
      },
    ].concat(serie.exploreMetrics.map((exploreMetric) => {
      return {
        field: exploreMetric.metric,
        filter: {[exploreMetric.metric]: 'text'},
        sortable: exploreMetric.metric,
        title: exploreMetric.title ? this.translate(exploreMetric.title) : this.translate(exploreMetric.metric),
        format: exploreMetric.format,
        show: true
      }
    }));

    res.explore_data.forEach(row => row['group_by_date'] = false);

    let queryWithGroupByDate = _.merge({}, serie.queryParams, res.query, {group_by_date: true, metric: serie.metric});
    serie.getData(queryWithGroupByDate)
      .then((res) => {
        this.addExploreDataBreakdownDimensionKeyAndValue(res, serie);

        let fields = _.chain(tableCols).map('field').value();
        let tableData = res.explore_data.map(row => {
          row['group_by_date'] = true;
          return _.pick(row, fields);
        });

        this.seriesTable.filter()['group_by_date'] = this.groupByDate;
        this.seriesTable.appendData(tableData);
      });

    return this.pieChartTransformResponse(res, serie, tableCols);
  };

  getSspLabel = (ssp_id) => {
    const sspData = _.find(this.sspsList, s => s.id === ssp_id);
    return sspData !== undefined ? sspData.valueToShow : 'N/A';
  }

  transformSspResponse(res, serie) {
    res.explore_data = res.explore_data.map((data) => {
      data.key = this.getSspLabel(data.ssp_id);
      data.value = data[serie.metric];
      return data;
    });

    let tableCols = [
      {
        field: 'keyOriginal',
        show: false
      },
      {
        field: 'date',
        sortable: 'date',
        title: 'Date',
        format: 'date',
        show: this.groupByDate
      },
      {
        field: 'key',
        sortable: 'ssp_id',
        title: serie.label,
        show: true
      },
    ].concat(serie.exploreMetrics.map((exploreMetric) => {
      return {
        field: exploreMetric.metric,
        sortable: exploreMetric.metric,
        title: exploreMetric.title ? this.translate(exploreMetric.title) : this.translate(exploreMetric.metric),
        format: exploreMetric.format,
        show: true
      }
    }));
    return this.pieChartTransformResponse(res, serie, tableCols);
  };


  transformPublisherResponse(res, serie) {
    res.explore_data = res.explore_data.map((data) => {
      data.key = data.publisher;
      data.value = data[serie.metric];
      return data;
    });

    let tableCols = [
      {
        field: 'keyOriginal',
        show: false
      },
      {
        field: 'date',
        sortable: 'date',
        title: 'Date',
        format: 'date',
        show: this.groupByDate
      },
      {
        field: 'publisher',
        sortable: 'publisher',
        title: serie.label,
        show: true
      },
      {
        field: 'bundle',
        sortable: 'bundle',
        title: this.translate('bundle'),
        show: true
      }
    ].concat(serie.exploreMetrics.map((exploreMetric) => {
      return {
        field: exploreMetric.metric,
        sortable: exploreMetric.metric,
        title: exploreMetric.title ? this.translate(exploreMetric.title) : this.translate(exploreMetric.metric),
        format: exploreMetric.format,
        show: true
      }
    }));

    return this.pieChartTransformResponse(res, serie, tableCols);
  };

  showBundleDetails(colField, bundle) {
    return colField === 'publisher' && bundle && bundle != 'unknown';
  }

  pieChartTransformResponse(res, serie, tableCols) {

    tableCols.forEach(col => {
      if(this.campaign.type == 'AcquisitionCPM' && _.includes(['Platforms', 'Countries', 'Publisher', 'Ssp', 'Bundle', 'Channels', 'Creative Dimension'], col.title)) {
        col.editBidPrice = true;
      }
      if('Publisher' === col.title) {
        col.bundleDetails = true;
      }

    });

    let query = res.query;
    let fields = _.chain(tableCols).map('field').value();
    let csvFields = _.chain(tableCols).filter({show: true}).map('field').value();

    let rows = res.explore_data.map((data) => {
      return {
        key: data.key,
        name: data.key,
        value: data.value,
        tooltipTitle: serie.label,
        tooltipValue: this.format(data.value, serie.format)
      }
    });

    _.remove(rows, function(row) {
      return row.value <= 0;
    });

    let tableData = res.explore_data.map((data) => {
      return _.pick(data, fields);
    });

    let csvData = [
      [serie.label].concat(serie.exploreMetrics.map(exploreMetric => exploreMetric.metric))
    ].concat(res.explore_data.map((data) => {
      return _.chain(data).pick(csvFields).values().value();
    }));

    const trimmedRows = _.take(_.orderBy(rows, ['value'], ['desc']), this.MAX_GRAPH_RESULTS);
    return {
      query,
      data: {rows: trimmedRows},
      tableCols,
      tableData,
      csvData,
      csvPostfix: serie.label
    };
  }

  enrichPublisherExploreData(res) {
    _.forEach(res.explore_data, (publisherData) => {
      publisherData.keyOriginal = publisherData.publisher_id;
      publisherData.publisher = publisherData.publisher_id;
    });
  }

  getEnrichedPublisherData(params) {
    return this.CampaignAnalyticsResource.one('explore').post('publisher', {
      filters: this.searchParams.ssps !== undefined ? [{dimension: 'ssp_id', comparison_keyword: 'IN', value: this.searchParams.ssps}] : []
    }, params).then((res) => {
      this.enrichPublisherExploreData(res);
      return res;
    });
  }

  getEnrichedSspData(params) {
    return this.CampaignAnalyticsResource.one('explore').post('publisher', {
      filters: this.searchParams.ssps !== undefined ? [{dimension: 'ssp_id', comparison_keyword: 'IN', value: this.searchParams.ssps}] : []
    }, params).then((res) => {
      return res;
    });
  }

  // function used to be spied upon in test, to check that API error catching happens
  handlePublisherExploreError() {}


  buildSeriesTable(serie) {
    if (serie.seriesName === 'publisher' || serie.seriesName === 'ssp') {
      let controllersThis = this;
      this.csv = new this.ggCSV();
      const breakdownParam = (serie.seriesName === 'ssp') ? {breakdown_dimension: 'ssp_id'} : {};
      this.seriesTable = new this.ggTable({
        csv: this.csv,
        count: 10,
        counts: [10, 30, 50, 100, 250],
        sorting: {impressions: 'desc'},
        getData: ((params) => {
          let query = _.merge(serie.queryParams, {
            campaign_id: this.campaign.id,
            start_date: this.apiDate(this.timeframe.startDate),
            end_date: this.apiDate(this.timeframe.endDate),
            page_num: params.parameters().page,
            row_num: params.parameters().count,
            order_by: _.keys(params.parameters().sorting)[0],
            order_direction: _.values(params.parameters().sorting)[0],
            group_by_date: this.groupByDate,
            ...breakdownParam
          });

          let filter = _.omit(params.filter(), ['group_by_date']);

          return this.CampaignAnalyticsResource.one('explore')
            .post('publisher', publisherTableFilterToClauses(filter, this.searchParams.ssps), query)
            .then((res) => {
              if (serie.seriesName === 'publisher') {
                this.enrichPublisherExploreData(res);
              }

              params.totals = _.cloneDeep(params.cols).map((total) => {
                if (total.field == 'date') {
                  total.format = 'number';
                  total.value = res.total_count;
                } else {
                  total.value = res.totals[total.field];
                }
                return total;
              });
              params.total(res.total_count);
              let data = res.explore_data.map((data) => {
                data.key = serie.seriesName === 'ssp' ? this.getSspLabel(data.ssp_id) : data.publisher;
                return data;
              });

              controllersThis.buildSeriesCsv(serie, params, _.omit(query, ['page_num', 'row_num']), filter)

              return data;
            }, (error) => {
              controllersThis.handlePublisherExploreError();
            });
        })
      });
    } else {
      this.csv = new this.ggCSV();
      this.seriesTable = new this.ggTable({
        csv: this.csv,
        count: 30,
        counts: [10, 30, 50, 100, 250],
        sorting: {date: 'asc'},
        enableCalculateTotals: true
      });
    }
  }

  buildSeriesCsv(serie, params, query, filter) {
    return this.CampaignAnalyticsResource.one('explore')
    .post('publisher', publisherTableFilterToClauses(filter, this.searchParams.ssps), query)
    .then((res) => {
      if (serie.seriesName === 'publisher') {
        this.enrichPublisherExploreData(res);
      }

      let csvData = res.explore_data.map((data) => {
        data.key = serie.seriesName === 'ssp' ? this.getSspLabel(data.ssp_id) : data.publisher;
        return data;
      });
      params.csv && params.csv.loadTableData(params.cols, csvData);
    }, (error) => {
    });
  }
}

export function CampaignsExploreComponent() {
  return {
    template,
    controller: CampaignsExploreController,
    restrict: 'E',
    controllerAs: 'vm',
    scope: {},
    bindToController: true
  };
};

export default angular.module('app.components.campaigns.explore', [
  'angularModalService',
  ConfigsModule.name,
  ServicesModule.name,
  ResourcesModule.name,
  CampaignVariationsGetter.name
])
  .directive('campaignsExplore', CampaignsExploreComponent);



/** WEBPACK FOOTER **
 ** ./src/components/campaigns/campaignsExplore.js
 **/